<template>
  <div
    id="admin-types-tables"
    class="mb-5">
    <v-container
      class="h-100 d-flex flex-column pt-0">
      <v-row>
        <!-- Call Statuses -->
        <v-col :cols="isMobile ? 12 : 6"
          v-if="isPermittedAll([
            'CallStatusCreate',
          ])">
          <div class="d-flex align-end">
            <label class="line-height-1 mb-1">Call Statuses:</label>
            <div class="ml-auto">
              <v-btn
                class="square mb-2"
                title="Add Call Status"
                type="button"
                color="primary"
                :disabled="$store.getters.isLoadingActive"
                @click="$store.dispatch(
                    'openCodeModalForm',
                    {
                      config: {
                        entity: 'Call Status',
                        property: 'CallStatusName',
                        createEndpoint: 'Calls/CreateCallStatus',
                        refresh: {
                          getEndpoint: 'Calls/GetAllCallStatus',
                          list: 'callStatuses',
                        },
                      },
                    },
                  )"
                block>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-data-table
            class="form-table"
            :headers="[
              {
                text: 'Call Status',
                value: 'CallStatusName',
              },
            ]"
            :items="$store.state.callStatuses"
            mobile-breakpoint="-1"
            item-key="CallStatusID"
            dense
            disable-pagination
            hide-default-footer
            fixed-header
            :options="{
              sortBy: ['CallStatusName'],
              rowsPerPage: -1,
            }">
            <template
              v-slot:item="row">
              <tr>
                <td>{{row.item.CallStatusName}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <!-- / Call Statuses -->

        <!-- Call Types -->
        <v-col :cols="isMobile ? 12 : 6"
          v-if="isPermittedAll([
            'CallTypesCreate',
          ])">
          <div class="d-flex align-end">
            <label class="line-height-1 mb-1">Call Types:</label>
            <div class="ml-auto">
              <v-btn
                class="square mb-2"
                title="Add Call Type"
                type="button"
                color="primary"
                :disabled="$store.getters.isLoadingActive"
                @click="$store.dispatch(
                    'openCodeModalForm',
                    {
                      config: {
                        entity: 'Call Type',
                        property: 'CallTypeName',
                        createEndpoint: 'Calls/CreateCallType',
                        refresh: {
                          getEndpoint: 'Calls/GetAllCallTypes',
                          list: 'callTypes',
                        },
                      },
                    },
                  )"
                block>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-data-table
            class="form-table"
            :headers="[
              {
                text: 'Call Type',
                value: 'CallTypeName',
              },
            ]"
            :items="$store.state.callTypes"
            mobile-breakpoint="-1"
            item-key="CallTypeID"
            dense
            disable-pagination
            hide-default-footer
            fixed-header
            :options="{
              sortBy: ['CallTypeName'],
              rowsPerPage: -1,
            }">
            <template
              v-slot:item="row">
              <tr>
                <td>{{row.item.CallTypeName}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <!-- / Call Types -->
      </v-row>

      <v-row>
        <!-- Customer Types -->
        <v-col :cols="isMobile ? 12 : 6"
          v-if="isPermittedAll([
            'CustomerTypesCreate',
          ])">
          <div class="d-flex align-end">
            <label class="line-height-1 mb-1">Customer Types:</label>
            <div class="ml-auto">
              <v-btn
                class="square mb-2"
                title="Add Customer Type"
                type="button"
                color="primary"
                :disabled="$store.getters.isLoadingActive"
                @click="$store.dispatch(
                    'openCodeModalForm',
                    {
                      config: {
                        entity: 'Customer Type',
                        property: 'CustomerTypeName',
                        createEndpoint: 'Customers/CreateCustomerType',
                        refresh: {
                          getEndpoint: 'Customers/GetAllCustomerTypes',
                          list: 'customerTypes',
                        },
                      },
                    },
                  )"
                block>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-data-table
            class="form-table"
            :headers="[
              {
                text: 'Customer Type',
                value: 'CustomerTypeName',
              },
            ]"
            :items="$store.state.customerTypes"
            mobile-breakpoint="-1"
            item-key="CustomerTypeID"
            dense
            disable-pagination
            hide-default-footer
            fixed-header
            :options="{
              sortBy: ['CustomerTypeName'],
              rowsPerPage: -1,
            }">
            <template
              v-slot:item="row">
              <tr>
                <td>{{row.item.CustomerTypeName}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <!-- / Customer Types -->

        <!-- Employee Titles -->
        <v-col :cols="isMobile ? 12 : 6"
          v-if="isPermittedAll([
            'EmployeeTitlesCreate',
          ])">
          <div class="d-flex align-end">
            <label class="line-height-1 mb-1">Employee Titles:</label>
            <div class="ml-auto">
              <v-btn
                class="square mb-2"
                title="Add Employee Title"
                type="button"
                color="primary"
                :disabled="$store.getters.isLoadingActive"
                @click="$store.dispatch(
                    'openCodeModalForm',
                    {
                      config: {
                        entity: 'Employee Title',
                        property: 'EmployeeTitleName',
                        createEndpoint: 'Employees/CreateEmployeeTitle',
                        refresh: {
                          getEndpoint: 'Employees/GetAllEmployeeTitles',
                          list: 'employeeTitles',
                        },
                      },
                    },
                  )"
                block>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-data-table
            class="form-table"
            :headers="[
              {
                text: 'Employee Title',
                value: 'EmployeeTitleName',
              },
            ]"
            :items="$store.state.employeeTitles"
            mobile-breakpoint="-1"
            item-key="EmployeeTitleID"
            dense
            disable-pagination
            hide-default-footer
            fixed-header
            :options="{
              sortBy: ['EmployeeTitleName'],
              rowsPerPage: -1,
            }">
            <template
              v-slot:item="row">
              <tr>
                <td>{{row.item.EmployeeTitleName}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <!-- / Employee Titles -->
      </v-row>

      <v-row>
        <!-- Software Types -->
        <v-col :cols="isMobile ? 12 : 6"
          v-if="isPermittedAll([
            'SoftwareTypesCreate',
          ])">
          <div class="d-flex align-end">
            <label class="line-height-1 mb-1">Software Types:</label>
            <div class="ml-auto">
              <v-btn
                class="square mb-2"
                title="Add Software Type"
                type="button"
                color="primary"
                :disabled="$store.getters.isLoadingActive"
                @click="$store.dispatch(
                    'openCodeModalForm',
                    {
                      config: {
                        entity: 'Software Type',
                        property: 'SoftwareTypeName',
                        createEndpoint: 'Computers/CreateSoftwareType',
                        refresh: {
                          getEndpoint: 'Computers/GetAllSoftwareTypes',
                          list: 'softwareTypes',
                        },
                      },
                    },
                  )"
                block>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-data-table
            class="form-table"
            :headers="[
              {
                text: 'Software Types',
                value: 'SoftwareTypeName',
              },
            ]"
            :items="$store.state.softwareTypes"
            mobile-breakpoint="-1"
            item-key="SoftwareTypeID"
            dense
            disable-pagination
            hide-default-footer
            fixed-header
            :options="{
              sortBy: ['SoftwareTypeName'],
              rowsPerPage: -1,
            }">
            <template
              v-slot:item="row">
              <tr>
                <td v-if="row.item.SoftwareTypeIsDeleted">
                  {{row.item.SoftwareTypeName}}
                  <v-icon @click="handleSoftwareTypeHiding(row.item)">mdi-eye-off</v-icon>
                </td>
                <td v-else>
                  {{row.item.SoftwareTypeName}}
                  <v-icon @click="handleSoftwareTypeHiding(row.item)">mdi-eye-outline</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <!-- / Software Types -->

        <!-- Purchasing Vendors -->
        <v-col :cols="isMobile ? 12 : 6"
          v-if="isPermittedAll([
            'PurchasingVendorsCreate',
          ])">
          <div class="d-flex align-end">
            <label class="line-height-1 mb-1">Purchasing Vendors:</label>
            <div class="ml-auto">
              <v-btn
                class="square mb-2"
                title="Add Purchasing Vendor"
                type="button"
                color="primary"
                :disabled="$store.getters.isLoadingActive"
                @click="$store.dispatch(
                    'openCodeModalForm',
                    {
                      config: {
                        entity: 'Purchasing Vendor',
                        property: 'PurchasingVendorName',
                        createEndpoint: 'Computers/CreatePurchasingVendor',
                        refresh: {
                          getEndpoint: 'Computers/GetAllPurchasingVendors',
                          list: 'purchasingVendors',
                        },
                      },
                    },
                  )"
                block>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-data-table
            class="form-table"
            :headers="[
              {
                text: 'Purchasing Vendor',
                value: 'PurchasingVendorName',
              },
            ]"
            :items="$store.state.purchasingVendors"
            mobile-breakpoint="-1"
            item-key="PurchasingVendorID"
            dense
            disable-pagination
            hide-default-footer
            fixed-header
            :options="{
              sortBy: ['PurchasingVendorName'],
              rowsPerPage: -1,
            }">
            <template
              v-slot:item="row">
              <tr>
                <td>{{row.item.PurchasingVendorName}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <!-- / Purchasing Vendors -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'AdminTypesTables',
  methods: {
    handleSoftwareTypeHiding(softwareType) {
      if (softwareType.SoftwareTypeIsDeleted) {
        this.$store.dispatch('unhideSoftwareType', softwareType);
      } else {
        this.$store.dispatch('hideSoftwareType', softwareType);
      }
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  created() {
    const softwareTypeParams = { params: { HiddenStatus: 'ShowAny' } };
    this.$store.dispatch('getCallStatuses');
    this.$store.dispatch('getCallTypes');
    this.$store.dispatch('getCustomerTypes');
    this.$store.dispatch('getEmployeeTitles');
    this.$store.dispatch('getSoftwareTypes', softwareTypeParams);
    this.$store.dispatch('getPurchasingVendors');
  },
};
</script>

<style lang="scss">
#admin-types-tables {
  overflow-y: auto;

  .form-table {
    .v-data-table__wrapper {
      max-height: 100%;
    }
  }
}
</style>
